import type { PlaceholderLabel } from './email-template-markup';

const PLACEHOLDER_ATTRIBUTE = 'data-placeholder';
const FILL_FIELD_ATTRIBUTE = 'data-fill-field';

function plainText(node: Node, placeholderLabel: PlaceholderLabel): string {
  if (node.nodeType === Node.TEXT_NODE) return node.textContent ?? '';

  if (node.nodeType !== Node.ELEMENT_NODE) return '';

  const element = node as Element;
  const placeholder = element.getAttribute(PLACEHOLDER_ATTRIBUTE);

  if (placeholder !== null) return `{${placeholderLabel(placeholder)}}`;

  const fillField = element.getAttribute(FILL_FIELD_ATTRIBUTE);

  if (fillField !== null) return `[${fillField}]`;

  if (element.tagName === 'BR') return ' ';

  return Array.from(element.childNodes)
    .map((child) => plainText(child, placeholderLabel))
    .join('');
}

/** The one-line text form of a stored subject: „Ihre Anfrage zu {Objekttitel}“, a fill-in field as „[Termin]“. */
export function toPlainLabel(markup: string, placeholderLabel: PlaceholderLabel): string {
  const body = new DOMParser().parseFromString(markup, 'text/html').body;

  return plainText(body, placeholderLabel).replace(/\s+/g, ' ').trim();
}
